import { delUser, queryUserList } from '@api/roleManagement';
import { DeletePrompt } from '@components/Popup/Prompt/deletePrompt';
import ZeissTable from '@components/table';
import { RoleSalesPopup } from '@views/pages/RoleManagement/Popup/sales';
import SearchCriteriaForm from '@views/pages/RoleManagement/searchCriteriaForm';
import type { TableProps } from 'antd';
import { PaginationProps, Space, message } from 'antd';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useImmer } from 'use-immer';
import { ROLEIDLIST } from '../type';
import { use_ROLESALESN_COLUMNS } from './columns';
import './index.scss';
interface RecordData {
  username?: string;
  email?: string;
  phone?: string;
  userId?: string;
}

interface PageProps {
  pageNumber: number;
  pageSize: number;
}
export const useRoleSales = ({
  roleIdList,
  refreshSaleTable,
  dicList
}: ROLEIDLIST) => {
  const searchCriteriaFromRef = useRef<any>(null); //搜索条件表单
  const [data, setData] = useImmer([]);
  const [delUserId, setDelUserId] = useState('');
  const [open, setOpen] = useState(false); //修改弹框
  const [total, setTotal] = useState<number>(0);
  const [deletePopStaus, setDeletePopStaus] = useState(false); //删除弹框
  const [recordData, setRecordData] = useImmer<RecordData>({}); //选中的表格行数据
  const [pageInfo, setPageInfo] = useImmer<PageProps>({
    pageNumber: 1,
    pageSize: 10
  });
  const ROLESALESN_COLUMNS = use_ROLESALESN_COLUMNS();
  //分页
  const pageProps: PaginationProps = {
    current: pageInfo.pageNumber,
    pageSize: pageInfo.pageSize,
    total: total
  };

  //显示删除框
  const handleClickDel = (id: string) => {
    setDeletePopStaus(true);
    setDelUserId(id);
  };

  //显示修改框
  const handleClickEdit = (record: RecordData) => {
    setOpen(true);
    setRecordData({});
    setRecordData(record);
  };

  const columns: TableProps<RecordData>['columns'] = [
    ...ROLESALESN_COLUMNS,
    {
      title: '操作',
      key: 'action',
      width: 200,
      align: 'center',
      fixed: 'right',
      render: (record: RecordData) => (
        <Space size="large">
          <a onClick={() => handleClickEdit(record)}>修改</a>
          <div
            className="pc-roleAdmin-del"
            onClick={() => handleClickDel(record?.userId || '')}
          >
            删除
          </div>
        </Space>
      )
    }
  ];

  const getDataSource = async (props: any = {}) => {
    const { current, pageSize, ...rest } = props;
    const res = await queryUserList({
      ...pageInfo,
      pageNumber: current || 1,
      pageSize: pageSize || 10,
      roleId: roleIdList?.Sales?.roleId,
      ...rest
    });
    setPageInfo({
      pageNumber: current || 1,
      pageSize: pageSize || 10
    });
    setTotal(res?.users?.total);
    setData(res?.users?.records || []);
  };

  const deleteAccount = async () => {
    await delUser({
      userIds: [delUserId]
    });
    setOpen(false);
    message.success('删除成功!');
    getDataSource();
  };

  const handleChange = ({ current, pageSize }: any) => {
    getDataSource({ current, pageSize });
  };

  const handleInputSubmit = async () => {
    const val = await searchCriteriaFromRef.current?.submitClick();
    getDataSource(val);
  };

  useEffect(() => {
    if (roleIdList.Sales !== undefined) getDataSource();
  }, [roleIdList.Sales]);

  useEffect(() => {
    if (refreshSaleTable && roleIdList.Sales) getDataSource(); //新增后刷新页面
  }, [refreshSaleTable]);

  const roleSalesComponent = (
    <>
      <SearchCriteriaForm
        ref={searchCriteriaFromRef}
        onFieldsChange={_.debounce(handleInputSubmit, 600)}
      />
      <ZeissTable
        className="pc-sales-table"
        columns={columns}
        dataSource={data}
        onChange={handleChange}
        bordered={false}
        pagination={pageProps}
        scroll={{ x: 1700 }}
      />
      <DeletePrompt
        popupTitle="确认删除该账号？"
        open={deletePopStaus}
        setOpen={setDeletePopStaus}
        confirmCallback={deleteAccount}
      />
      {open && (
        <RoleSalesPopup
          getDataSource={getDataSource}
          record={recordData}
          dicList={dicList}
          open={open}
          setOpen={setOpen}
          currentTabKey="Sales"
        />
      )}
    </>
  );

  return {
    roleSalesComponent
  };
};
